export default {
  ENV: 'testing',
  BASE_URL: 'https://api-staging-internal.mozio.com',
  BASE_URL_V2: 'https://api-staging-internal.mozio.com/v2',
  WL_BOOTSTRAP_URL: 'https://front-end-staging.mozio.com/?wl=',
}
